import { Component, OnInit, isDevMode, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HelpersService } from 'src/app/services';
import { PartnerService } from '../../../../../services/partner.service';
import { RentalsService } from '../../../../../services/rentals.service';
import { PaymentService } from '../../../../../services/payment.service';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-rentals-split-payment-configuration',
  templateUrl: './rentals-split-payment-configuration.component.html',
  styleUrls: ['./rentals-split-payment-configuration.component.scss'],
})
export class RentalsSplitPaymentConfigurationComponent implements OnInit {
  public busy: boolean = false;
  public configuaration: any = {};
  public partner: any = {};
  public RentalConfigForm: FormGroup;

  constructor(
    private translate: TranslateService,
    private helpersService: HelpersService,
    public partnerService: PartnerService,
    public rentalsService: RentalsService,
    private paymentService: PaymentService,
    private messageService: MessageService,
    private fb: FormBuilder,
  ) {}

  ngOnInit() {
    this.partner = this.helpersService.getPartnerData();
    this.getConfiguration();
  }

  getConfiguration() {
    this.rentalsService
      .getRentalSplitPaymentConfiguration(this.helpersService.getPartnerId())
      .subscribe((configuaration) => {
        console.log(configuaration);
        this.configuaration = configuaration;
        this.setupValidation();
      });
  }

  setupValidation() {
    this.RentalConfigForm = this.fb.group({
      allowForRentalsGreaterThan: new FormControl(
        this.configuaration.allowForRentalsGreaterThan,
        [Validators.required, Validators.min(1)],
      ),
      allowForRentalsGreaterThanUnitTypeID: new FormControl(
        this.configuaration.allowForRentalsGreaterThanUnitTypeID,
        [Validators.required, Validators.min(2), Validators.max(4)],
      ),
      allowSplitPayments: new FormControl(
        this.configuaration.allowSplitPayments,
        [Validators.required],
      ),
      billOnFirstOfNextBillingCycle: new FormControl(
        this.configuaration.billOnFirstOfNextBillingCycle,
        [Validators.required],
      ),
      firstPaymentCollectedAsDeposit: new FormControl(
        this.configuaration.firstPaymentCollectedAsDeposit,
        [Validators.required],
      ),
      minimumInitialPayment: new FormControl(
        this.configuaration.minimumInitialPayment,
        [Validators.required, Validators.min(0)],
      ),
      paymentFrequency: new FormControl(this.configuaration.paymentFrequency, [
        Validators.required,
        Validators.min(1),
      ]),
      paymentFrequencyUnitTypeID: new FormControl(
        this.configuaration.paymentFrequencyUnitTypeID,
        [Validators.required, Validators.min(2), Validators.max(4)],
      ),
      allowFullPayment: new FormControl(this.configuaration.allowFullPayment, [
        Validators.required,
      ]),
    });

    this.RentalConfigForm.get('allowSplitPayments').valueChanges.subscribe(
      (value) => {
        if (value) {
          this.RentalConfigForm.get('allowForRentalsGreaterThan').setValidators(
            [Validators.required, Validators.min(1)],
          );
          this.RentalConfigForm.get(
            'allowForRentalsGreaterThanUnitTypeID',
          ).setValidators([
            Validators.required,
            Validators.min(2),
            Validators.max(4),
          ]);
          this.RentalConfigForm.get(
            'billOnFirstOfNextBillingCycle',
          ).setValidators(Validators.required);
          this.RentalConfigForm.get(
            'firstPaymentCollectedAsDeposit',
          ).setValidators(Validators.required);
          this.RentalConfigForm.get('minimumInitialPayment').setValidators([
            Validators.required,
            Validators.min(0),
          ]);
          this.RentalConfigForm.get('paymentFrequency').setValidators([
            Validators.required,
            Validators.min(1),
          ]);
          this.RentalConfigForm.get('paymentFrequencyUnitTypeID').setValidators(
            [Validators.required, Validators.min(2), Validators.max(4)],
          );
          this.RentalConfigForm.get('allowFullPayment').setValidators(
            Validators.required,
          );
        } else {
          this.RentalConfigForm.get('allowForRentalsGreaterThan').setValidators(
            Validators.nullValidator,
          );
          this.RentalConfigForm.get(
            'allowForRentalsGreaterThanUnitTypeID',
          ).setValidators(Validators.nullValidator);
          this.RentalConfigForm.get(
            'billOnFirstOfNextBillingCycle',
          ).setValidators(Validators.nullValidator);
          this.RentalConfigForm.get(
            'firstPaymentCollectedAsDeposit',
          ).setValidators(Validators.nullValidator);
          this.RentalConfigForm.get('minimumInitialPayment').setValidators(
            Validators.nullValidator,
          );
          this.RentalConfigForm.get('paymentFrequency').setValidators(
            Validators.nullValidator,
          );
          this.RentalConfigForm.get('paymentFrequencyUnitTypeID').setValidators(
            Validators.nullValidator,
          );
          this.RentalConfigForm.get('allowFullPayment').setValidators(
            Validators.nullValidator,
          );
        }

        this.RentalConfigForm.get(
          'allowForRentalsGreaterThan',
        ).updateValueAndValidity();
        this.RentalConfigForm.get(
          'allowForRentalsGreaterThanUnitTypeID',
        ).updateValueAndValidity();
        this.RentalConfigForm.get(
          'billOnFirstOfNextBillingCycle',
        ).updateValueAndValidity();
        this.RentalConfigForm.get(
          'firstPaymentCollectedAsDeposit',
        ).updateValueAndValidity();
        this.RentalConfigForm.get(
          'minimumInitialPayment',
        ).updateValueAndValidity();
        this.RentalConfigForm.get('paymentFrequency').updateValueAndValidity();
        this.RentalConfigForm.get(
          'paymentFrequencyUnitTypeID',
        ).updateValueAndValidity();
        this.RentalConfigForm.get('allowFullPayment').updateValueAndValidity();
      },
    );

    // this.RentalConfigForm.get('firstPaymentCollectedAsDeposit').valueChanges.subscribe(value => {
    //   console.log(value)
    //   if(value){
    //     this.RentalConfigForm.get('minimumInitialPayment').enable();
    //   }else{
    //     this.RentalConfigForm.get('minimumInitialPayment').disable();
    //   }
    //   this.RentalConfigForm.get('minimumInitialPayment').updateValueAndValidity();
    // });
  }

  saveConfig(data) {
    this.busy = true;
    let update = {
      ...this.configuaration,
      ...data,
    };

    this.rentalsService.updateRentalSplitPaymentConfiguration(update).subscribe(
      (partner) => {
        this.busy = false;
        this.messageService.add({
          life: 5000,
          detail: this.translate.instant(
            'bikeshop.service_deposit_configuration.updated_configuration',
          ),
          closable: false,
        });
      },
      (err) => {
        this.busy = false;
      },
    );
  }
}
